import { render, staticRenderFns } from "./PaymentsReviewPolicyNumberCell.vue?vue&type=template&id=2558fe92&"
import script from "./PaymentsReviewPolicyNumberCell.vue?vue&type=script&lang=js&"
export * from "./PaymentsReviewPolicyNumberCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports